import gql from "graphql-tag";
import AssetDiscussionCommentReplyFields from "../../fragments/AssetDiscussionCommentReplyFields";

export default gql`
  mutation EditAssetDiscussionCommentReply($replyId: ObjectID!, $bodyAsPlainText: String!) {
    editAssetDiscussionCommentReply(replyId: $replyId, bodyAsPlainText: $bodyAsPlainText) {
      _id
      ...AssetDiscussionCommentReplyFields
    }
  }

  ${AssetDiscussionCommentReplyFields}
`;
